<template>
  <ul>
    <aside-menu-item
      :item="menu"
      :is-submenu-list="isSubmenuList"
      @menu-click="menuClick"
    />
  </ul>
</template>

<script>
  /* eslint-disable */
  import AsideMenuItem from '@/components/AsideMenuItem'

  export default {
    name: 'Aside Menu List',

    components: {
      AsideMenuItem
    },

    props: {
      isSubmenuList: { type: Boolean, default: false },
      menu: { type: Array, default: () => [] }
    },
    setup (props, { emit }) {
      const menuClick = (event, item) => {
        emit('menu-click', event, item)
      }

      return {
        menuClick
      }
    }
  }
</script>
